// src/components/CustomerView/fields/DocumentIdentificationField.tsx
import React from 'react';
import InfoField from '../../../Shared/InfoField';
import { ICustomerDetail } from '../../../../types/customer/customerInterfaces';

interface Props {
  detail: ICustomerDetail;
}

const v = (x?: string | null) => x ?? '—';

const DocumentIdentificationField: React.FC<Props> = ({ detail }) => {
  const typeId = detail.documentIdentificationTypeId;

  if (!typeId) return null;

  switch (typeId) {
    case 1:
      return <InfoField label="NIT" value={v(detail.nit)} />;
    case 2:
      return <InfoField label="DUI" value={v(detail.dui)} />;
    case 3:
      return <InfoField label="Otra Identificación" value={v(detail.otherIdentification)} />;
    case 4:
      return <InfoField label="Pasaporte" value={v(detail.passportNumber)} />;
    case 5:
      return <InfoField label="Carnet de Residente" value={v(detail.residentCardNumber)} />;
    default:
      return null;
  }
};

export default DocumentIdentificationField;
